import {makeAuthRequest} from '../makeApiRequest'

const apiRequest = makeAuthRequest(true)
const prefix = process.env.REACT_APP_LABEL_SERVICE_API || 'api/label'
//const prefix = 'http://localhost:8864'
export const uploadLabelUK = (payload) => {
    return apiRequest({
        url: `${prefix}/labels-uk/upload?overwrite=1`,
        method: 'POST',
        data: payload
    })
}

export const labelUploadParse = (payload) => {
    return apiRequest({
        url: `${prefix}/label-upload`,
        method: 'POST',
        data: payload
    })
}

export const listLabels = (payload) => {
    return apiRequest({
        url: `${prefix}/labels/search`,
        method: 'POST',
        data: payload
    })
}

export const listLabelsV2 = (payload) => {
    return apiRequest({
        url: `${prefix}/v2/labels/search`,
        method: 'POST',
        data: payload
    })
}

export const deleteLabel = (labelId) => {
    return apiRequest({
        url: `${prefix}/labels/${labelId}`,
        method: 'DELETE'
    })
}

export const updateNoteLabel = (labelId, payload) => {
    return apiRequest({
        url: `${prefix}/labels/${labelId}/note`,
        method: 'POST',
        data: payload
    })
}

export const listLabelUpload = (query) => {
    return apiRequest({
        url: `${prefix}/label-upload/tasks?${query}`,
        method: 'GET'
    })
}

export const retryGenLabel = (labelId) => {
    return apiRequest({
        url: `${prefix}/retry/${labelId}`,
        method: 'PUT'
    })
}

export const getAbleToParseLabel = (barcode) => {
    return apiRequest({
        url: `${prefix}/labels/${barcode}/able-to-paste-label`,
        method: 'GET'
    })
}

export const isShippedLabel = (barcode) => {
    return apiRequest({
        url: `${prefix}/labels/${barcode}/shipped`,
        method: 'POST'
    })
}

export const getInformationLabel = (barcode) => {
    return apiRequest({
        url: `${prefix}/labels/${barcode}`,
        method: 'GET'
    })
}
